import { makeStyles } from '@material-ui/core/styles'
import WhyChooseTrovity from 'src/assets/Policy_Details_Images/WhyChooseTrovity.svg'
import ComingSoon from 'src/assets/Policy_Details_Images/ComingSoon.svg'
import TrovityImage from 'src/assets/Policy_Details_Images/TrovityImage.svg'
import ProfileImage from 'src/assets/Policy_Details_Images/ProfileImage.svg'
import {
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import {
  GET_ACCOUNT_MANAGER_DETAILS,
  GET_INSURANCE_TYPES,
  getBuyInsurance,
} from 'src/services/individualService'
import React, { useState } from 'react'
import call from 'src/assets/Policy_Details_Images/call.svg'
import WhatsApp from 'src/assets/Policy_Details_Images/WhatsApp.svg'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { useQuery } from '@apollo/client'
import { getFullName, getInsuranceTypesList } from 'src/utils/commonMethods'
import LoadingModal from 'src/components/common/LoadingModal'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { useDispatch } from 'react-redux'
import {
  CANNOT_RAISE_THE_REQUEST,
  ENCOUNTERED_ERROR,
  PHONE,
  REQUEST_CAPTURED,
} from 'src/utils/constants/Ceo'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { INVALID_NUMBER } from 'src/utils/constants/Individual'

const BuyInsurance = ({ clientId, emailId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    insuranceType: '',
    name: '',
    phone: '',
    isPhoneValid: true,
    emailId,
    clientId,
  })

  const [loading, setLoading] = useState(false)

  const phoneRegex = /^\d{10}$/

  const handleInputChange = (event) => {
    const { name, value } = event?.target
    const isPhoneValid = name === PHONE ? phoneRegex?.test(value) : true
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      isPhoneValid,
    }))
  }

  const handleSubmit = async (event) => {
    event?.preventDefault()
    if (formData?.emailId) {
      await buyInsurance()
    } else {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.WARNING,
          message: CANNOT_RAISE_THE_REQUEST,
        })
      )
    }
  }

  const buyInsurance = async () => {
    setLoading(true)
    delete formData['isPhoneValid']
    const response = await getBuyInsurance(formData)
    try {
      setLoading(false)
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }

      if (response?.res?.data?.success) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.SUCCESS,
            message: REQUEST_CAPTURED,
          })
        )

        setFormData({
          insuranceType: '',
          name: '',
          phone: '',
          isPhoneValid: true,
        })
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: ENCOUNTERED_ERROR,
        })
      )
    }
  }

  const {
    loading: insuranceTypesAggregateLoading,
    error: insuranceTypesAggregateError,
    data,
  } = useQuery(GET_INSURANCE_TYPES(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: accountManagerDetailsLoading,
    error: accountManagerDetailsError,
    data: accountManagerDetailsData,
  } = useQuery(GET_ACCOUNT_MANAGER_DETAILS(clientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  if (insuranceTypesAggregateLoading || accountManagerDetailsLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    )

  if (insuranceTypesAggregateError || accountManagerDetailsError)
    return (
      <>
        <GraphQlErrors
          error={insuranceTypesAggregateError || accountManagerDetailsError}
          routeValue={'back'}
        />
      </>
    )

  const accountManagerDetails =
    accountManagerDetailsData?.getAccountManagerDetails?.accountManagerDetails

  const insuranceTypesList = getInsuranceTypesList(
    data?.getMasterData?.response?.[0]?.data
  )

  return (
    <>
      <LoadingModal loading={loading} />
      <div>
        <div className={classes.buyCorporateContainer}>
          <div>
            <div className={classes.buyCorporateHeading}>
              To Buy Corporate Insurance
            </div>
            <div className={classes.headingContent}>
              <div>
                <span className={classes.text}>
                  Your Dedicated Key <br></br> Account Manager
                </span>
              </div>
              <div>
                {accountManagerDetails?.imageUrL ? (
                  <img
                    src={accountManagerDetails.imageUrL}
                    alt='buyInsuranceImage'
                    className={classes.buyImage}
                  />
                ) : (
                  <img
                    src={ProfileImage}
                    alt='buyInsuranceImage'
                    className={classes.buyImage}
                  />
                )}
              </div>
              {accountManagerDetails !== null ? (
                <>
                  <div>
                    <span className={classes.textName}>
                      {getFullName([
                        accountManagerDetails?.firstName,
                        accountManagerDetails?.lastName,
                      ])}
                    </span>
                    <br></br>
                    <span className={classes.textSubName}>
                      Insurance Expert
                    </span>
                  </div>
                  <div>
                    <span className={classes.textSubName}>
                      {accountManagerDetails?.phoneNumber}
                    </span>
                    <br></br>
                    <span className={classes.textSubName}>
                      {accountManagerDetails?.mail}
                    </span>
                  </div>
                </>
              ) : (
                <div>
                  <span className={classes.textName}>
                    No Account Manager Assigned
                  </span>
                </div>
              )}
              <div className={classes.contactCallContainer}>
                <div className={classes.callContent}>
                  <div>
                    <img src={call} alt='call' />
                  </div>
                  <div>
                    <span className={classes.callText}>Call</span>
                  </div>
                </div>
                <div className={classes.callContent}>
                  <div>
                    <img src={WhatsApp} alt='whatsApp' />
                  </div>
                  <div>
                    <span className={classes.callText}>Chat</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.contactContainer}>
            <div className={classes.contactHeading}>Contact Us</div>
            <div className={classes.contactContent}>
              <form onSubmit={handleSubmit} id='buyInsuranceForm'>
                <div className={classes.contactHeadingContent}>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>
                      Type of Insurance
                    </span>
                    <FormControl fullWidth>
                      <Select
                        labelId='typeOfInsurance'
                        id='insuranceType'
                        name='insuranceType'
                        placeholder='Insurance Type'
                        displayEmpty
                        defaultValue=''
                        value={formData?.insuranceType}
                        onChange={(event) => handleInputChange(event)}
                        className={classes.insuranceTypeField}
                      >
                        <MenuItem
                          value={''}
                          className={'default-menu-item'}
                          disabled
                        >
                          Insurance Type
                        </MenuItem>
                        {insuranceTypesList?.map((subType) => (
                          <MenuItem
                            key={`insuranceType_${subType}`}
                            value={subType}
                          >
                            {subType}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>Name</span>
                    <br></br>
                    <TextField
                      id='name'
                      name='name'
                      type='text'
                      placeholder='Name Here'
                      value={formData?.name}
                      onChange={(event) => handleInputChange(event)}
                      required
                      className={classes.nameField}
                    />
                  </div>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>Phone Number</span>
                    <br></br>
                    <TextField
                      id='phone'
                      name='phone'
                      type='number'
                      placeholder='+91'
                      value={formData.phone}
                      onChange={(event) => {
                        event.target.value = Math.max(
                          0,
                          parseInt(event?.target?.value)
                        )
                          ?.toString()
                          ?.slice(0, 10)
                        handleInputChange(event)
                      }}
                      required
                      error={!formData?.isPhoneValid}
                      helperText={!formData?.isPhoneValid ? INVALID_NUMBER : ''}
                      className={classes.nameField}
                    />
                  </div>
                </div>
                <div className={classes.submit}>
                  <Button
                    type='submit'
                    className={classes.submitText}
                    id='submitButton'
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className={classes.trovityContainer}>
          <div>
            <div className={classes.trovityHeading}>
              <span>Why Choose Trovity</span>
            </div>
            <div>
              <span className={classes.trovityText}>
                Let us handle your insurance
              </span>
              <br></br>
              <span className={classes.trovitySubText}>
                so you can concentrate on your work without worries
              </span>
            </div>
          </div>
          <div>
            <img
              src={WhyChooseTrovity}
              alt='whyChooseTrovity'
              className={classes.WhyChooseImage}
            />
          </div>
        </div>
        <div className={classes.trovityEdgeContainer}>
          <div className={classes.trovityEdgeContent}>
            <div>
              <span className={classes.content}>
                Choosing the right insurance policy can make a significant
                difference during claims.{' '}
              </span>
            </div>
            <hr></hr>
            <div>
              <span className={classes.content}>
                Trovity comprehends your business intricacies.
              </span>
            </div>
            <hr></hr>
            <div>
              <span className={classes.content}>
                Based on detailed risk reports and gap analysis, we recommend
                policies that cover essential aspects, ensuring you don&apos;t
                miss vital protections.
              </span>
            </div>
          </div>
          <div className={classes.edgeContainer}>
            <div>
              <span className={classes.contentHeading}>Trovity Edge</span>
            </div>
            <div>
              <span className={classes.text}>
                Our team comprises certified underwriters who expertly manage
                your insurance portfolio.
              </span>
            </div>
          </div>
        </div>
        <hr className={classes.hr}></hr>
        <div className={classes.comingSoonContainer}>
          <div>
            <img
              src={ComingSoon}
              alt='comingSoon'
              className={classes.comingSoonImage}
            />
          </div>
          <div>
            <div className={classes.comingSoonText}>
              Coming Soon! <span className={classes.comingSoonQMS}>(QMS)</span>
            </div>
            <div className={classes.ComingSoonSubText}>
              The Quotation Management System will be available,
            </div>
            <div className={classes.ComingSoon}>
              {' '}
              allowing you to access and review quotes conveniently online.
            </div>
          </div>
        </div>
        <hr className={classes.hr}></hr>
        <div className={classes.trovityDescriptionContainer}>
          <div className={classes.descriptionContent}>
            <img
              src={TrovityImage}
              alt='trovityImage'
              className={classes.trovityImage}
            />
            <div>
              <span className={classes.description}>
                Real-Life Consequences
              </span>
            </div>
          </div>
          <div className={classes.descriptionText}>
            Few companies buy fire insurance without proper coverage. They
            undervalue their property to pay lower premiums or opt for coverage
            that aligns with book values.
          </div>
          <div className={classes.descriptionSubText}>
            Unfortunately, this can lead to reduced claim settlements, causing
            distress and financial challenges during the claim process.
          </div>
        </div>
      </div>
    </>
  )
}
export default BuyInsurance
const useStyles = makeStyles({
  trovityContainer: {
    display: 'flex',
    padding: '20px 0px',
    gap: '30px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  trovityHeading: {
    fontSize: '30px',
    lineHeight: '40px',
    textAlign: 'right',
    fontWeight: '700',
    padding: '80px 0px 40px 0px',
  },
  WhyChooseImage: {
    maxWidth: '287px',
    width: '100%',
  },
  trovityText: {
    fontSize: '38px',
    color: '#00A6D3',
    fontWeight: '300',
    lineHeight: '35px',
    textAlign: 'right',
  },
  trovitySubText: {
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '30px',
    textAlign: 'right',
  },
  content: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  contentHeading: {
    fontSize: '27px',
    fontWeight: '700',
    lineHeight: '38px',
    color: '#B92250',
  },
  insuranceTypeField: {
    '&  .MuiSelect-select': {
      height: '0.7rem !important',
      minHeight: 'unset !important',
      fontSize: '12px',
    },
  },
  nameField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
      fontStyle: 'italic',
      fontSize: '12px',
    },
  },
  contentText: {
    fontSize: '21px',
    lineHeight: '25px',
    fontWeight: '400',
  },
  trovityImage: {
    width: '120px',
  },
  description: {
    fontSize: '19px',
    lineHeight: '25px',
    fontWeight: '400',
    borderLeft: '2px solid rgba(77, 77, 77, 1)',
  },
  descriptionText: {
    fontSize: '17px',
    fontWeight: '600',
    fontStyle: 'italic',
    lineHeight: '22px',
    paddingBottom: '20px',
    color: '#000000',
  },
  descriptionSubText: {
    fontSize: '17px',
    fontWeight: '400',
    lineHeight: '22px',
  },
  hr: {
    color: '#4DC3E3',
  },
  comingSoonContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 40px',
    gap: '30px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  comingSoonImage: {
    width: '240px',
  },
  trovityEdgeContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 0px',
    justifyContent: 'center,',
  },
  trovityEdgeContent: {
    borderRight: '4px solid #D9D9D9',
    padding: '20px',
  },
  trovityDescriptionContainer: {
    textAlign: 'center',
    padding: '20px 0px',
  },
  descriptionContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    paddingBottom: '20px',
  },
  edgeContainer: {
    padding: '10px',
  },
  comingSoonText: {
    fontSize: '26px',
    color: '#7D7D7D',
    lineHeight: '34px',
    fontWeight: '300',
    padding: '10px 0px',
  },
  comingSoonQMS: {
    fontWeight: '400',
    color: '#32ADCE',
  },
  ComingSoonSubText: {
    fontSize: '17px',
    fontWeight: '700',
    color: '#32ADCE',
    lineHeight: '22px',
  },
  ComingSoon: {
    color: '#000000',
    fontWeight: '600',
  },
  buyCorporateContainer: {
    display: 'flex',
    gap: '30px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '10px',
  },
  buyCorporateHeading: {
    fontSize: '20px',
    fontWeight: '400',
    color: '#B92250',
    lineHeight: '22px',
    padding: '20px 0px',
  },
  headingContent: {
    border: '1px solid #B92250',
    borderRadius: '15px',
    background: '#EDEDED',
    padding: '20px',
    textAlign: 'center',
    boxShadow: '0px 5px 5px 0px #00000033',
  },
  text: {
    fontSize: '13px',
    lineHeight: '15px',
    color: '#B92250',
    fontWeight: '600',
  },
  buyImage: {
    width: '132px',
    padding: '10px',
  },
  textName: {
    fontSize: '15px',
    lineHeight: '17px',
    fontWeight: '600',
    textTransform: 'capitalize',
    textAlign: 'center',
  },
  textSubName: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
  },
  contactHeading: {
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#2F2F2F',
    padding: '20px 0px',
  },
  contactContent: {
    border: '1px solid #C0C0C0',
    borderRadius: '15px',
    padding: '20px',
    textAlign: 'center',
    boxShadow: '0px 5px 5px 0px #00000033',
  },
  submit: {
    border: '1px solid #EF669B',
    borderRadius: '20px',
    width: '85px',
    marginTop: '50px',
    marginLeft: '60px',
  },
  submitText: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '15px',
    color: '#B92250 !important',
    padding: '10px',
  },
  contactTextContent: {
    width: '190px',
    padding: '10px',
  },
  contactHeadingContent: {
    textAlign: 'start',
  },
  contactContainer: {
    textAlign: 'center',
  },
  contactText: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: '400',
  },
  callContent: {
    border: '1px solid #EF669B',
    borderRadius: '20px',
    display: 'flex',
    gap: '8px',
    padding: '5px 10px',
  },
  contactCallContainer: {
    display: 'flex',
    gap: '5px',
    padding: '10px 0px',
    justifyContent: 'center',
  },
  callText: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '15px',
    color: '#B92250',
  },
})
